'use client';

import dayjs from 'dayjs';
import { useEffect, useState } from 'react';

import { Image } from '@/components/client';

interface CertificateCardProps {
  year: number | null;
  name: string;
}

export const CertificateCard = ({ year, name }: CertificateCardProps) => {
  const [currentDate, setCurrentDate] = useState(() =>
    dayjs().format('YYYY.MM.DD HH:mm:ss'),
  );

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentDate(dayjs().format('YYYY.MM.DD HH:mm:ss'));
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <article className="relative h-[25.5rem] w-280 overflow-hidden rounded-large bg-B-100 shadow-lg flex-center">
      <div className="h-full w-[calc(100%-50px)] animate-spin bg-gradient-to-r from-[#90D5FF] to-[#38A7FF] animate-duration-[5000ms] animate-infinite" />

      <div className="absolute left-1 top-1 m-auto flex size-[calc(100%-2px)] flex-col items-center rounded-large bg-Gray-25 pt-40">
        <div className="flex flex-col items-center">
          {year !== null && (
            <p className="mb-12 rounded-xsmall bg-O-400 px-6 py-2 font-600 text-Gray-white typo-caption1">
              {year}년차
            </p>
          )}
          <p className="pb-4 font-800 text-Gray-900 typo-h5">탐나는 제주패스</p>
          <p className="font-400 text-Gray-700 typo-body4">기부확인증</p>
        </div>

        <Image
          src="https://cdn.welfarehello.com/static/jeju-certificate.png"
          alt="탐나는 제주패스"
          width={350}
          height={214}
          className="my-25 h-107 w-175"
        />

        <div className="flex flex-col items-center">
          <p className="pb-8 font-800 text-Gray-900 typo-h4">{name}</p>
          <p className="pb-17 font-400 text-Gray-700 typo-body4">
            제주특별자치도
          </p>
          <div className="flex items-center gap-8">
            <span className="font-600 text-Gray-700 typo-caption1">
              현재시각
            </span>
            <span className="font-400 text-Gray-600 typo-caption1">
              {currentDate}
            </span>
          </div>
        </div>
      </div>
    </article>
  );
};
